import { c as _c } from "react/compiler-runtime";
import { Maybe } from '@/utils/types';
import { useTranslation } from 'react-i18next';
interface Props {
  value: Maybe<string>;
}
export function Duration(t0) {
  const $ = _c(4);
  const {
    value
  } = t0;
  const {
    t
  } = useTranslation("career");
  switch (value) {
    case "indefinite":
      {
        let t1;
        if ($[0] !== t) {
          t1 = t("duration.indefinite");
          $[0] = t;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case "definite":
      {
        let t1;
        if ($[2] !== t) {
          t1 = t("duration.definite");
          $[2] = t;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    default:
      {
        return null;
      }
  }
}